export default "__VITE_ASSET__CfqY16QD__"